import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Badge } from '@els/els-react--badge';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { isStateSameOrParent } from '@Utils/router-state';
import { isTexelAccessEnabled } from '@Services/Texel/TexelAccess';
import { NavGroup } from '@els/els-react--nav-group';
import NavMenuItems from './NavMenuItems';

import '@els/els-react--nav-group/dist/els-styleguide-nav-group.scss';
import './GeneralMenuItems.scss';

function GeneralMenuItemsComponent({
  activeResults,
  isAnonymousUser,
  isRMCLicense,
  goToTexel,
  history,
  goToResults,
  onItemClick,
  isTablet = false,
}) {
  const [activeNavItem, setActiveNavItem] = useState(null);
  const texelAccessEnabled = isTexelAccessEnabled();

  useEffect(() => {
    const pathName = history.location.pathname;
    const activeItem = Object.values(NavMenuItems).find(
      (item) => isStateSameOrParent(pathName, item.path) || (item.id === NavMenuItems.results.id && pathName.indexOf('/results/') >= 0)
    );
    setActiveNavItem(activeItem ? activeItem.id : null);
  }, [history.location.pathname]);

  const handleGoToResults = () => {
    if (activeResults) {
      if (typeof onItemClick === 'function') {
        onItemClick();
      }
      goToResults();
    }
  };

  const getLinks = () => {
    const baseLinks = [
      NavMenuItems.quickSearch,
      NavMenuItems.queryBuilder,
      NavMenuItems.results,
      ...(!isRMCLicense ? [NavMenuItems.retrosynthesis] : []),
      NavMenuItems.history,
      ...(isAnonymousUser ? [] : [NavMenuItems.alerts]),
      ...(texelAccessEnabled ? [NavMenuItems.texel] : []),
    ];

    return baseLinks.map((item) => {
      const linkProps = {
        id: item.id,
        children: item.label,
        href: item.path,
        onClick: (event) => {
          if (typeof onItemClick === 'function') {
            onItemClick();
          }
          if (item.id === NavMenuItems.results.id) {
            handleGoToResults();
          } else if (item.id === NavMenuItems.texel.id) {
            event.preventDefault();
            goToTexel();
          }
        },
        routerComponent: Link,
        routerHrefAttribute: 'to',
      };

      if (item.id === NavMenuItems.results.id && !activeResults) {
        linkProps.className = 'c-els-link--disabled';
      }

      if (item.id === NavMenuItems.texel.id) {
        linkProps.children = (
          <>
            {item.label}
            <Badge
              content="Beta"
              isNotificationDot={isTablet}
              className="link-vector-search__badge u-els-background-color-extended-purple-1"
            />
          </>
        );
        linkProps.href = RequestUrls?.texelLinkout?.url;
        linkProps.isExternal = true;
        linkProps.noExternalIcon = true;
        linkProps.routerComponent = undefined;
        linkProps.routerHrefAttribute = undefined;
      }

      return linkProps;
    });
  };

  return (
    <NavGroup
      title="Main"
      linkElementData={getLinks()}
      activeId={activeNavItem}
      activeIsLink
      aria-current={activeNavItem}
      id="main-site-navigation"
    />
  );
}

GeneralMenuItemsComponent.propTypes = {
  goToResults: PropTypes.func.isRequired,
  goToTexel: PropTypes.func.isRequired,
  isRMCLicense: PropTypes.bool,
  activeResults: PropTypes.bool,
  isAnonymousUser: PropTypes.bool,
  history: PropTypes.object,
  onItemClick: PropTypes.func,
  isTablet: PropTypes.bool,
};

const GeneralMenuItems = withRouter(GeneralMenuItemsComponent);
export default GeneralMenuItems;
